var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout",
    [
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c("loading", {
            attrs: {
              active: _vm.isLoading,
              "can-cancel": false,
              "is-full-page": true
            },
            on: {
              "update:active": function($event) {
                _vm.isLoading = $event
              }
            }
          }),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "px-5", attrs: { lg: "12" } },
                [
                  _c("system-details", {
                    attrs: { system: _vm.system, type: "config", compact: true }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "pr-lg-5", attrs: { lg: "4" } },
                        [
                          _c("b-row", {}, [
                            _c(
                              "div",
                              { staticClass: "ellipse-content-header" },
                              [
                                _c("h1", {}, [
                                  _vm._v(_vm._s(_vm.$t("titles.applications")))
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c("b-table", {
                                attrs: {
                                  responsive: "",
                                  "sticky-header": "37rem",
                                  striped: "",
                                  hover: "",
                                  items: _vm.applications,
                                  small: "",
                                  fields: _vm.fields.applications
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "head(enabled)",
                                    fn: function(data) {
                                      return [
                                        _c("b-form-checkbox", {
                                          attrs: { size: "sm" },
                                          on: {
                                            change: function($event) {
                                              return _vm.toggleAllApplications()
                                            }
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                            }
                                          },
                                          model: {
                                            value: _vm.selectAll.applications,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selectAll,
                                                "applications",
                                                $$v
                                              )
                                            },
                                            expression: "selectAll.applications"
                                          }
                                        })
                                      ]
                                    }
                                  },
                                  {
                                    key: "head(application)",
                                    fn: function(data) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "table.headers.application"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "head(credit_per_shot)",
                                    fn: function(data) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "table.headers.credit_per_shot"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(enabled)",
                                    fn: function(row) {
                                      return [
                                        _c("b-form-checkbox", {
                                          attrs: { size: "sm" },
                                          on: {
                                            change: function($event) {
                                              _vm.toggle(row, "applications")
                                              _vm.refresh(row)
                                            }
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                            }
                                          },
                                          model: {
                                            value: row.item.enabled,
                                            callback: function($$v) {
                                              _vm.$set(row.item, "enabled", $$v)
                                            },
                                            expression: "row.item.enabled"
                                          }
                                        })
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(credit_per_shot)",
                                    fn: function(row) {
                                      return [
                                        _c(
                                          "div",
                                          [
                                            _c("b-form-select", {
                                              attrs: {
                                                options:
                                                  _vm.types
                                                    .perShotCreditCostType
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.refresh(row)
                                                }
                                              },
                                              model: {
                                                value: row.item.credit_per_shot,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    row.item,
                                                    "credit_per_shot",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "row.item.credit_per_shot"
                                              }
                                            }),
                                            _vm._v(" "),
                                            row.error === true
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "error-label force-up"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "errors.selectionRequired"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "px-lg-5", attrs: { lg: "4" } },
                        [
                          _c("b-row", [
                            _c(
                              "div",
                              { staticClass: "ellipse-content-header" },
                              [
                                _c("h1", {}, [
                                  _vm._v(_vm._s(_vm.$t("titles.applicators")))
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c("b-table", {
                                attrs: {
                                  responsive: "",
                                  "sticky-header": "37rem",
                                  striped: "",
                                  hover: "",
                                  items: _vm.applicators,
                                  small: "",
                                  fields: _vm.fields.applicators
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "head(enabled)",
                                    fn: function(data) {
                                      return [
                                        _c("b-form-checkbox", {
                                          attrs: { size: "sm" },
                                          on: {
                                            change: function($event) {
                                              return _vm.toggleAllApplicators()
                                            }
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                            }
                                          },
                                          model: {
                                            value: _vm.selectAll.applicators,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selectAll,
                                                "applicators",
                                                $$v
                                              )
                                            },
                                            expression: "selectAll.applicators"
                                          }
                                        })
                                      ]
                                    }
                                  },
                                  {
                                    key: "head(applicator)",
                                    fn: function(data) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("table.headers.applicator")
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "head(cost_factor)",
                                    fn: function(data) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "table.headers.cost_factor"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(enabled)",
                                    fn: function(row) {
                                      return [
                                        _c("b-form-checkbox", {
                                          attrs: { size: "sm" },
                                          on: {
                                            change: function($event) {
                                              _vm.toggle(row, "applicators")
                                              _vm.refresh(row)
                                            }
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                            }
                                          },
                                          model: {
                                            value: row.item.enabled,
                                            callback: function($$v) {
                                              _vm.$set(row.item, "enabled", $$v)
                                            },
                                            expression: "row.item.enabled"
                                          }
                                        })
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(cost_factor)",
                                    fn: function(row) {
                                      return [
                                        _c(
                                          "div",
                                          [
                                            _c("b-form-select", {
                                              attrs: {
                                                options:
                                                  _vm.types
                                                    .applicatorCostFactorType
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.refresh(row)
                                                }
                                              },
                                              model: {
                                                value: row.item.cost_factor,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    row.item,
                                                    "cost_factor",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "row.item.cost_factor"
                                              }
                                            }),
                                            _vm._v(" "),
                                            row.error === true
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "error-label force-up"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "errors.selectionRequired"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "pl-lg-5", attrs: { lg: "4" } },
                        [
                          _c("b-row", [
                            _c(
                              "div",
                              { staticClass: "ellipse-content-header" },
                              [
                                _c("h1", {}, [
                                  _vm._v(_vm._s(_vm.$t("titles.swmodules")))
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("b-form-checkbox-group", {
                                    attrs: {
                                      stacked: "",
                                      options: _vm.swModules
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.refresh({
                                          item: { type: "sw" }
                                        })
                                      }
                                    },
                                    model: {
                                      value: _vm.selectedSwModules,
                                      callback: function($$v) {
                                        _vm.selectedSwModules = $$v
                                      },
                                      expression: "selectedSwModules"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-row", [
                            _c(
                              "div",
                              { staticClass: "ellipse-content-header" },
                              [
                                _c("h1", {}, [
                                  _vm._v(
                                    _vm._s(_vm.$t("titles.regulatoryAuthority"))
                                  )
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { staticClass: "px-0 mb-4" },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.regulatoryAuthorities
                                    },
                                    model: {
                                      value: _vm.system.RegulatoryAuthority,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.system,
                                          "RegulatoryAuthority",
                                          $$v
                                        )
                                      },
                                      expression: "system.RegulatoryAuthority"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _vm._l(_vm.errors.response.list, function(error) {
                        return _c(
                          "b-alert",
                          {
                            key: error.Message,
                            attrs: {
                              show: "",
                              dismissible: "",
                              variant: "danger"
                            }
                          },
                          [_vm._v(_vm._s(error.Message))]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "b-alert",
                        {
                          attrs: {
                            variant: "danger",
                            show: _vm.errors.applications
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("errors.applicationConfig")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-alert",
                        {
                          attrs: {
                            variant: "danger",
                            show: _vm.errors.applicators
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("errors.applicatorConfig"))
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-alert",
                        {
                          attrs: {
                            variant: "danger",
                            show: _vm.errors.applicationSelection
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("errors.minApplications")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-alert",
                        {
                          attrs: {
                            variant: "danger",
                            show: _vm.errors.applicatorSelection
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("errors.minApplicators")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-alert",
                        {
                          attrs: {
                            variant: "danger",
                            show: _vm.errors.swSelection
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("errors.minSwModules")))]
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "min-width-button",
                                  attrs: {
                                    type: "button",
                                    variant: "outline-secondary",
                                    "active-class": "",
                                    to: {
                                      name: "issue-system-config",
                                      params: { logosid: this.system.LogosID }
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("buttons.back")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  staticClass: "min-width-button ml-2",
                                  attrs: {
                                    type: "button",
                                    variant: "outline-secondary",
                                    "active-class": ""
                                  },
                                  on: { click: _vm.save }
                                },
                                [_vm._v(_vm._s(_vm.$t("buttons.continue")))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("send-config-by-mail-modal", {
        ref: "complete",
        attrs: {
          type: "config",
          email: _vm.email,
          system: _vm.system,
          file: _vm.files.license
        },
        on: { accept: _vm.redirectToCreditOverview }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17bf1237", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17bf1237","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./WebApp/components/IssueAdvancedSystemConfig.vue
// module id = 763
// module chunks = 0